import {
  generalFundAdministrationText,
  simulatorText as simulatorGlobalText,
} from 'presentation/constant/globals'

export const simulatorText = simulatorGlobalText
export const generalBackgroundHistoryText = generalFundAdministrationText
